import React, { PropsWithChildren, useMemo, useState } from 'react';

import { Modal } from '@opendoor/bricks/complex';
import { getRailsEnv } from '@opendoor/shared-fe/railsEnv';

import { ReauthContext, ReauthOptions, ReauthResult } from 'platform/components/ReauthContext';
import { ReauthForm } from 'platform/components/ReauthForm';

/** Provides ReauthContext so that components can call showReauth from anywhere.  */
export const ReauthProvider: React.FC<PropsWithChildren> = ({ children }) => {
  // The last caller of showReauth, or undefined if never called.
  const [caller, setCaller] = useState<ReauthOptions>();
  const contextValue: ReauthResult = useMemo(
    () => ({
      showReauth: (options) =>
        setCaller((prevCaller) => {
          if (prevCaller) {
            if (getRailsEnv() !== 'production') {
              // eslint-disable-next-line no-console -- dev only consoles
              console.warn(
                'showReauth called twice! The second showReauth call will be ignored. This warning only shows up in non-production builds.',
              );
            }
            return prevCaller;
          }
          return options;
        }),
    }),
    [setCaller],
  );
  return (
    <ReauthContext.Provider value={contextValue}>
      {children}
      {caller ? (
        <Modal
          analyticsName="cake-reauth-modal"
          isOpen={true}
          onRequestClose={() => {
            setCaller(undefined);
            caller.onCancel();
          }}
          headerProps={{
            title: caller.title || 'Sign in again to continue',
          }}
        >
          <ReauthForm
            onSuccess={() => {
              setCaller(undefined);
              caller.onSuccess();
            }}
          />
        </Modal>
      ) : (
        <Modal analyticsName="" aria-labelledby="" isOpen={false} />
      )}
    </ReauthContext.Provider>
  );
};
